// extracted by mini-css-extract-plugin
export default {"no-result":"UserSelector_no-result_Zotc8"};